module.exports = __webpack_public_path__ + "img/Industrial & Scientific.fa7b7a87.png";